import { render, staticRenderFns } from "./SubjectDetail.vue?vue&type=template&id=a480f2e0&scoped=true&"
import script from "./SubjectDetail.vue?vue&type=script&lang=js&"
export * from "./SubjectDetail.vue?vue&type=script&lang=js&"
import style0 from "./SubjectDetail.vue?vue&type=style&index=0&id=a480f2e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a480f2e0",
  null
  
)

export default component.exports